export default __webpack_public_path__ + "static/f8-c6995896cd4541cee3c522d14e734bb4.svg";